<div class="container">
  <div class="stepper">
    <div class="stepContainer">
      <div class="step">1</div>
    </div>
    <div class="stepContainer">
      <div class="step">2</div>
    </div>
    <div class="stepContainer active">
      <div class="step">3</div>
    </div>
    @if (shouldDisplayFourthStep()) {
      <div class="stepContainer">
        <div class="step">4</div>
      </div>
    }
  </div>
  <div class="titleContainer marginTop">
    <div class="title">{{ "onboarding.3.title" | translate }}</div>
  </div>
  <div class="graphismGrid row row-gap-10">
    <div
      class="graphismContainer marginTop col-12 col-sm-6 col-md-4"
      [class.active]="selectedGraphism === 'manga'"
      >
      <div (click)="select('manga')" class="graphismCard manga">
        <img
          class="styleImage"
          src="assets/modules/manga/identite_numerique.png"
          draggable="false"
          />
        <div class="title">{{ "onboarding.3.manga" | translate }}</div>
        <div class="iconsContainer">
          <div class="iconContainer">
            <img
              src="assets/modules/manga/reseaux_sociaux.png"
              draggable="false"
              />
          </div>
          <div class="iconContainer">
            <img
              src="assets/modules/manga/intelligence_artificielle.png"
              draggable="false"
              />
          </div>
          <div class="iconContainer">
            <img
              src="assets/modules/manga/dependance_numerique.png"
              draggable="false"
              />
          </div>
        </div>
      </div>
    </div>
    <div
      class="graphismContainer marginTop col-12 col-sm-6 col-md-4"
      [class.active]="selectedGraphism === 'low-poly'"
      >
      <div (click)="select('low-poly')" class="graphismCard lowpoly">
        <img
          class="styleImage"
          src="assets/modules/low-poly/decrypter_info.png"
          draggable="false"
          />
        <div class="title">
          {{ "onboarding.3.lowpoly" | translate }}
        </div>
        <div class="iconsContainer">
          <div class="iconContainer">
            <img
              src="assets/modules/low-poly/cyber_harcelement.png"
              draggable="false"
              />
          </div>
          <div class="iconContainer">
            <img
              src="assets/modules/low-poly/intelligence_artificielle.png"
              draggable="false"
              />
          </div>
          <div class="iconContainer">
            <img
              src="assets/modules/low-poly/numerique_attitude.png"
              draggable="false"
              />
          </div>
        </div>
      </div>
    </div>
    <div
      class="graphismContainer marginTop col-12 col-sm-6 col-md-4"
      [class.active]="selectedGraphism === 'vectoriel'"
      >
      <div (click)="select('vectoriel')" class="graphismCard vecto">
        <img
          class="styleImage"
          src="assets/modules/vectoriel/numerique_attitude.png"
          draggable="false"
          />
        <div class="title">{{ "onboarding.3.illus" | translate }}</div>
        <div class="iconsContainer">
          <div class="iconContainer">
            <img
              src="assets/modules/vectoriel/intelligence_artificielle.png"
              draggable="false"
              />
          </div>
          <div class="iconContainer">
            <img
              src="assets/modules/vectoriel/identite_numerique.png"
              draggable="false"
              />
          </div>
          <div class="iconContainer">
            <img
              src="assets/modules/vectoriel/reseaux_sociaux.png"
              draggable="false"
              />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="nextBtnContainer">
    <div
      (click)="next()"
      class="nextButton"
      [class.disabled]="selectedGraphism === undefined"
      >
      {{ "common.buttons.next" | translate }}
    </div>
  </div>
</div>
